import React from 'react';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';

interface UserBalanceProps {
  balances: {
    id: number,
    typeCode: number,
    name: string,
    balance: number,
    lastUpdate: string,
    creditBalance: number,
    debitBalance: number
  }[]
}

function UserBalance({ balances }: UserBalanceProps) {
  const { t } = useTranslation();

  return (
    <div className="transaction-group">
      <div className="transaction-group__header transaction-group__header--balance ">
        <span>{ t('transactions.id') }</span>
        <span>{ t('transactions.typeCode') }</span>
        <span>{ t('transactions.name') }</span>
        <span>{ t('transactions.creditBalance') }</span>
        <span>{ t('transactions.debitBalance') }</span>
        <span>{ t('transactions.balance') }</span>
        <span>{ t('transactions.updatedAt') }</span>
      </div>
      <div className="transaction-group__body">
        {
          balances &&
          _.map(balances, (group) => {
            return (
              <div className="transaction-group__item transaction-group__item--balance" key={ group.id }>
                <span>{ group.id }</span>
                <span>{ group.typeCode }</span>
                <span>{ group.name }</span>
                <span>{ (+group.creditBalance / 100).toFixed(2) }</span>
                <span>{ (+group.debitBalance / 100).toFixed(2) }</span>
                <span>{ (+group.balance / 100).toFixed(2) }</span>
                <span>{ group.lastUpdate }</span>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

export default UserBalance;
